import { render, staticRenderFns } from "./kftc.vue?vue&type=template&id=d6429114&scoped=true"
import script from "./kftc.vue?vue&type=script&lang=js"
export * from "./kftc.vue?vue&type=script&lang=js"
import style0 from "./kftc.vue?vue&type=style&index=0&id=d6429114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6429114",
  null
  
)

export default component.exports